module.exports = __webpack_public_path__ + "static/media/everyday_digital_newspaper.d10128de.png";